const server = process.env.REACT_APP_API_SERVER || 'local';
let API_URL;

if (server === 'local') {
  API_URL = 'http://localhost:8000/api';
} else if (server === 'imr-prod') {
  API_URL = 'https://imr-prod.herokuapp.com/api';
} else if (server === 'imr-dev') {
  API_URL = 'https://imr-dev.herokuapp.com/api';
}

export function fetchSampleGroups() {
  const request = new Request(`${API_URL}/sample_groups/`);
  return fetch(request).then(response => response.json());
}

export function fetchSequencingRuns() {
  const request = new Request(`${API_URL}/runs/`);
  return fetch(request).then(response => response.json());
}

export function fetchSiteAttributes() {
  const request = new Request(`${API_URL}/site_attributes/1/`);
  return fetch(request).then(response => response.json());
}
